import { TFunction } from 'react-i18next';
import { VariableDataType } from 'ts-components/inputs/ValueInput/types';

export const getAutomationVariablesCategoryName = (t: TFunction) =>
  t('Agentic Workflow Variables');

const automationVariableOption = (
  name: string,
  idSuffix: string,
  displayName: string,
  baseField: any
) => ({
  ...baseField,
  name: `${name}.${idSuffix}`,
  id: `automation_variable.${name}.${idSuffix}`,
  isDefault: false,
  displayName,
  fieldPrefix: 'automation_variable',
});

export const automationVariable = (
  name: string,
  displayName: string,
  meta: {
    dataType: VariableDataType;
    dataSubtype: { id: string; value: string };
  },
  baseField: any,
  clientObjectId: string,
  t: TFunction
) => {
  if (meta.dataType === 'employee') {
    // id, full_name, email
    return [
      automationVariableOption(
        name,
        'id',
        t('{{displayName}} (ID)', { displayName }),
        baseField
      ),
      automationVariableOption(
        name,
        'full_name',
        t('{{displayName}} (Full Name)', { displayName }),
        baseField
      ),
      automationVariableOption(
        name,
        'email',
        t('{{displayName}} (Email)', { displayName }),
        baseField
      ),
    ];
  }
  if (meta.dataType === 'entity') {
    if (
      meta?.dataSubtype.value === clientObjectId ||
      meta?.dataSubtype.id === clientObjectId
    ) {
      // id, full_name, email
      return [
        automationVariableOption(
          name,
          'id',
          t('{{displayName}} (ID)', { displayName }),
          baseField
        ),
        automationVariableOption(
          name,
          'full_name',
          t('{{displayName}} (Full Name)', { displayName }),
          baseField
        ),
        automationVariableOption(
          name,
          'email',
          t('{{displayName}} (Email)', { displayName }),
          baseField
        ),
      ];
    } else {
      // id, name, display_name
      return [
        automationVariableOption(
          name,
          'id',
          t('{{displayName}} (ID)', { displayName }),
          baseField
        ),
        automationVariableOption(
          name,
          'name',
          t('{{displayName}} (Name)', { displayName }),
          baseField
        ),
        automationVariableOption(
          name,
          'display_name',
          t('{{displayName}} (Display Name)', { displayName }),
          baseField
        ),
      ];
    }
  }

  return [
    {
      ...baseField,
      name,
      id: `automation_variable.${name}`,
      isDefault: false,
      displayName,
      fieldPrefix: 'automation_variable',
    },
  ];
};

export const baseAutomationVariable = (label: string, value: string) => ({
  label,
  relationship: `automation_variable.${value}`,
  key: value,
});

export const firstField = {
  access: { view: true },
  options: [],
  relation: null,
};
